// biome-ignore lint/style/noVar: <explanation>
declare var window: Window;

export const isTacticAppWebView = () => {
  //@ts-ignore
  if (typeof window === 'undefined') return false;

  // Check for the presence of the Tactic App WebView user agent
  //@ts-ignore
  const userAgent = window.navigator.userAgent || '';
  return userAgent.includes('TacticMobileAppWebView');
};
